import React, { useState, useEffect } from 'react';
import Footer from '../../components/footer/Footer';
import { GetUrl } from '../../config/GetUrl';
import { toast } from 'react-toastify';
import axios from 'axios';
import Sidebars from '../../components/sidebars/Sidebars';
import Header from '../../components/header/Header';
import { Nav, Tab } from 'react-bootstrap';
import Loader from '../../components/Loader';

const MAX_BANNER_PREVIEW_SIZE = 100 * 1024; // 100 KB
const MAX_BANNER_VIDEO_SIZE = 1024 * 1024 * 10; // 10 MB

const AboutContent = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [aboutContent, setAboutContent] = useState({
    aboutBodyTitle: '',
    aboutBodyDescription1: '',
    aboutBodyDescription2: '',
    homeBannerTitle: '',
    bannerDescription: '',
    bodyTitle: '',
    bodyDescription: '',
    footerTitle: '',
    footerDescription: '',
    aboutBodyImage: '',
    homeBodyImage: '',
    homeBannerImage: '',
    aboutBannerImage: '',
    aboutBannerDescription: '',
    footerImages: [],
    aboutLeftType: 'image',
    homeBannerPreview: '',
  });
  const [previewImages, setPreviewImages] = useState({
    aboutBodyImage: '',
    homeBodyImage: '',
    aboutBannerImage: '',
    homeBannerImage: '',
    footerImages: [],
    homeBannerPreview: '',
  });
  const [previewVideos, setPreviewVideos] = useState({
    aboutVideo: '',
    homeVideo: '',
    homeBannerVideo:''
    
  });

  useEffect(() => {
    fetchAboutContent();
  }, []);

  const fetchAboutContent = async () => {
    try {
      setShowLoader(true);
      setIsLoading(true);
      const response = await axios.get(`${GetUrl.API_URL}/api/v1/Admin/getAboutContent`);
      if (response.data.status) {
        console.log({ response })
        setAboutContent(prev => ({
          ...prev,
          ...response.data.data,
          footerImages: response.data.data.footerImages || []
        }));
        setPreviewImages({
          aboutBodyImage: response.data.data.aboutBodyImage,
          homeBodyImage: response.data.data.homeBodyImage,
          aboutBannerImage: response.data.data.aboutBannerImage,
          homeBannerImage: response.data.data.homeBannerImage,
          footerImages: response.data.data.footerImages || [],
          homeBannerPreview: response.data.data.homeBannerPreview,
        });
        setPreviewVideos({
          aboutVideo: response.data.data.aboutVideo,
          homeVideo: response.data.data.homeVideo,
          homeBannerVideo:response.data.data.homeBannerVideo,
          aboutLeftVideo:response.data.data.aboutLeftVideo
        });
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error fetching about content');
    } finally {
          setIsLoading(false);
      setShowLoader(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAboutContent(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleImageChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      if (name === 'footerImages') {
        // Handle multiple footer images
        const newFiles = Array.from(files);
        setAboutContent(prev => ({
          ...prev,
          footerImages: [...prev.footerImages, ...newFiles]
        }));
        
        // Create preview URLs for new images
        const newPreviewUrls = newFiles.map(file => URL.createObjectURL(file));
        setPreviewImages(prev => ({
          ...prev,
          footerImages: [...prev.footerImages, ...newPreviewUrls]
        }));
      } else {
        // Validate homeBannerPreview size
        if (name === 'homeBannerPreview') {
          if (files[0].size > MAX_BANNER_PREVIEW_SIZE) {
            toast.error('Home Banner Preview size must be 100 KB or less');
            e.target.value = '';
            return;
          }
        }
        setAboutContent(prev => ({
          ...prev,
          [name]: files[0]
        }));
        
        if (name.includes('Image') || name === 'homeBannerPreview') {
          setPreviewImages(prev => ({
            ...prev,
            [name]: URL.createObjectURL(files[0])
          }));
        }
      }
    }
  };

    const handleVideoChange = (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      setAboutContent(prev => ({
        ...prev,
        [name]: files[0]
      }));
      
      if (name.includes('Video')) {
        setPreviewVideos(prev => ({
          ...prev,
          [name]: URL.createObjectURL(files[0])
        }));
      }
    }
  };

  const removeFooterImage = (index) => {
    setAboutContent(prev => ({
      ...prev,
      footerImages: prev.footerImages.filter((_, i) => i !== index)
    }));
    setPreviewImages(prev => ({
      ...prev,
      footerImages: prev.footerImages.filter((_, i) => i !== index)
    }));
  };

  const removeVideo = (videoType) => {
    setAboutContent(prev => ({
      ...prev,
      [videoType]: null
    }));
    setPreviewVideos(prev => ({
      ...prev,
      [videoType]: ''
    }));
  };

  const handleLeftTypeChange = (type) => {
    setAboutContent(prev => ({
      ...prev,
      aboutLeftType: type
    }));
  };

  const validateForm = () => {
    // homeBannerPreview required and size check
    if (!aboutContent.homeBannerPreview && !previewImages.homeBannerPreview) {
      toast.error('Home Banner Preview is required');
      return false;
    }
    if (aboutContent.homeBannerPreview instanceof File && aboutContent.homeBannerPreview.size > MAX_BANNER_PREVIEW_SIZE) {
      toast.error('Home Banner Preview size must be 100 KB or less');
      return false;
    }
  
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    try {
      setShowLoader(true);
       setIsLoading(true);
      const formData = new FormData();
       Object.keys(aboutContent).forEach(key => {
        if (key === 'footerImages') {
          // Handle multiple footer images
          aboutContent[key].forEach((file, index) => {
            formData.append(`footerImages`, file);
          });
        } else if (key === 'aboutVideo') {
          console.log({key})
          // Handle aboutVideo specifically
          if (aboutContent[key] instanceof File) {
            console.log("I am instance of file " , aboutContent[key])
            formData.append(key, aboutContent[key]);
          } else {
            formData.append(key, aboutContent[key] || '');
          }
        } else if (key.includes('Image') || key.includes('Video')) {
          if (aboutContent[key] instanceof File) {
            formData.append(key, aboutContent[key]);
          }
        } else {
          formData.append(key, aboutContent[key]);
        }
      });

      // Ensure selected Home Banner Video is actually included
    const homeBannerVideoInput = document.querySelector('input[name="homeBannerVideo"]');
    if (homeBannerVideoInput?.files?.[0]) {
      formData.set('homeBannerVideo', homeBannerVideoInput.files[0]);
    }

    const response = await axios.post(
        `${GetUrl.API_URL}/api/v1/Admin/updateAboutContent`,
        formData,
        {
          headers: {
            'authorization': `Bearer ${localStorage.getItem('tokenAdmin')}`
          }
        }
      );

      if (response.data.status) {
        toast.success('About content updated successfully');
        fetchAboutContent();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error updating about content');
    } finally {
       setIsLoading(false);
      setShowLoader(false);
    }
  };

  return (
    <>
      <Sidebars />
      <Header />
      <main id="main" className="content main mt-0 h-100 min-vh-80">
        <div className="container-fluid allCards-new mobile-image-width mobile-px-0">
          <div className="row">
            <div className="col-md-12">
              <div className="clearfix mt-3 mb-4">
                <div className="float-start">
                  <h2 className="text-contact">Static Content</h2>
                </div>
              </div>
            </div>
          </div>
          {isLoading && <Loader />}
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit} className="form-login">
                    <Tab.Container defaultActiveKey="footer">
                      <Nav variant="tabs" className="mb-4">
                        
                        
                        <Nav.Item>
                          <Nav.Link
                            eventKey="footer"
                            style={{ color: '#15865F' }}
                            className="nav-link-custom"
                          >
                            Footer
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>

                      <style>
                        {`
                          .nav-link-custom {
                            color: #15865F !important;
                          }
                          .nav-link-custom.active {
                            color: #15865F !important;
                            font-weight: bold;
                          }
                        `}
                      </style>

                      <Tab.Content>
                        {/* Home Section */}
                        

                        {/* About Section */}
                        

                        {/* Footer Section */}
                        <Tab.Pane eventKey="footer">
                          <div className="row">
                            <div className="col-md-6 mb-4">
                              <label className="form-label">Footer Title</label>
                              <input
                                type="text"
                                name="footerTitle"
                                value={aboutContent.footerTitle}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="Enter Footer Title"
                              />
                            </div>
                            <div className="col-md-6 mb-4">
                              <label className="form-label">Footer Description</label>
                              <textarea
                                name="footerDescription"
                                value={aboutContent.footerDescription}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder="Enter Footer Description"
                                rows="3"
                              />
                            </div>
                          </div>
                          
                          {/* Multiple Footer Images Section */}
                          <div className="row">
                            <div className="col-md-12 mb-4">
                              <label className="form-label">Footer Images</label>
                              <input
                                type="file"
                                name="footerImages"
                                onChange={handleImageChange}
                                className="form-control"
                                accept="image/*"
                                multiple
                              />
                              <small className="text-muted">You can select multiple images</small>
                            </div>
                          </div>

                          {/* Preview Footer Images */}
                          <div className="row">
                            {previewImages.footerImages.map((image, index) => (
                              <div key={index} className="col-md-3 mb-4 position-relative">
                                <img
                                  src={image}
                                  alt={`Footer Image ${index + 1}`}
                                  className="img-fluid rounded"
                                  style={{ width: '100%', height: '200px', objectFit: 'cover' }}
                                />
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                  onClick={() => removeFooterImage(index)}
                                >
                                  <i class="bi bi-x"></i>
                                </button>
                              </div>
                            ))}
                          </div>
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>

                    <div className="text-center mb-4 mt-4">
                      <button
                        type="submit"
                        className="btn bg-button py-3 text-white"
                        style={{ width: '200px' }}
                      >
                        Update
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default AboutContent; 